import React from "react";

export function EditIcon() {
  return <i className="fas fa-edit"></i>;
}
